<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div>
        <template v-if="wallet">
          E-Wallet Balance: <strong>{{ $formatting.toCurrency(wallet.balance) }}</strong>
        </template>
      </div>
      <div>
        <base-button modal="#addInvestmentStatement" secondary>
          Add Statement Item
        </base-button>
        <button-upload class="ml-2" :path="`investments/${investment._id}/payments`" secondary @uploaded="makeBatchPayment">
          Upload Batch Payment
        </button-upload>
      </div>
    </div>
    <base-card tabled>
      <base-table v-if="statements">
        <thead>
          <tr>
            <th>Date</th>
            <th>Funding</th>
            <th>Description</th>
            <th>Credit</th>
            <th>Debit</th>
            <th>Capital</th>
            <th>Interest Due</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(statement, key) in statements" :key="key">
            <td>{{ $dates.toDate(statement.date) }}</td>
            <td>{{ statement.funding ? statement.funding.name : '' }}</td>
            <td>{{ statement.type.description }}</td>
            <td>
              <template v-if="statement.credit">
                {{ $formatting.toCurrency(statement.credit) }}
              </template>
            </td>
            <td>
              <template v-if="statement.debit">
                {{ $formatting.toCurrency(statement.debit) }}
              </template>
            </td>
            <td>
              <template v-if="statement.capital">
                {{ $formatting.toCurrency(statement.capital) }}
              </template>
            </td>
            <td>
              <template v-if="statement.interestDue">
                {{ $formatting.toCurrency(statement.interestDue) }}
              </template>
            </td>
          </tr>
        </tbody>
      </base-table>
    </base-card>
    <investment-statement-create-modal />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import ButtonUpload from './ButtonUpload.vue'
import InvestmentStatementCreateModal from './InvestmentStatementCreateModal.vue'

export default {
  name: 'InvestmentStatement',

  components: {
    ButtonUpload,
    InvestmentStatementCreateModal
  },

  created () {
    this.getStatements({
      query: {
        investment: this.investment._id
      }
    })

    this.getWalletDetails({
      investment: this.investment._id
    })
  },

  computed: {
    ...mapState({
      investment: store => store.core.investments.entity,
      statements: store => store.core.investmentStatements.rows,
      wallet: store => store.core.investments.getWalletDetails
    })
  },

  methods: {
    makeBatchPayment (document) {
      this.importBatchPayment({
        document: document._id,
        investment: this.investment._id
      })

      this.$flash.success('Batch payment requested')
    },

    ...mapActions({
      getStatements: 'core/investment-statements/list',
      getWalletDetails: 'core/investments/get-wallet-details',
      importBatchPayment: 'core/investments/import-batch-payment'
    })
  }
}
</script>
